import styled from 'styled-components';
export const SameValueTableCell = styled.p`
  color: #666666;
`;
export const OldValueTableCell = styled.p`
  color: red;
  text-decoration: line-through;
`;
export const NewValueTableCell = styled.p`
  color: green;
  padding-left: 0.5rem;
`;
export const ValueContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
`;